module.exports = __webpack_public_path__ + "img/25.91e3fd0c.png";